// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toc__root {
  position: sticky;
  top: 0;
  right: 0;
  margin-left: auto;
  padding-right: calc(var(--cms-padding) * 1px);
  align-self: stretch;
  max-width: 180px;
  min-width: 180px;
  height: 100%;
}
.toc__root .toc_container {
  position: sticky;
  top: 0;
  max-width: 180px;
  min-width: 180px;
}
@media (max-width: 768px) {
  .toc__root {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../editor/src/components/TableOfContent/TableOfContent.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".toc__root {\n  position: sticky;\n  top: 0;\n  right: 0;\n  margin-left: auto;\n  padding-right: calc(var(--cms-padding) * 1px);\n  align-self: stretch;\n  max-width: 180px;\n  min-width: 180px;\n  height: 100%;\n}\n.toc__root .toc_container {\n  position: sticky;\n  top: 0;\n  max-width: 180px;\n  min-width: 180px;\n}\n@media (max-width: 768px) {\n  .toc__root {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
